export const getItem = (item) => {
  try {
    const serializedItem = sessionStorage.getItem(item);
    if (serializedItem == null) {
      return undefined;
    }
    return JSON.parse(serializedItem);
  } catch (e) {
    return undefined;
  }
};

export const setItem = (key, value) => {
  try {
    const serializedItem = JSON.stringify(value);
    sessionStorage.setItem(key, serializedItem);
  } catch (e) {
    console.log(e.message);
  }
};

export const removeItem = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.log(e.message);
  }
};
